export const activityLogOwnerMemberId = 207;
export const superAdministratorMemberId = activityLogOwnerMemberId;

export function canViewActivityLog(user) {
  return user?.role === "administrator" && user?.memberId === activityLogOwnerMemberId;
}

export function canCurateCollegeDays(user) {
  return user?.role === "administrator" && user?.memberId === superAdministratorMemberId;
}
